import { call, put, takeEvery, all } from 'redux-saga/effects'
import myOffersTypes from './myOffersTypes'
import * as myOffersActions from './myOffersActions'
import * as initActions from './../initReducer/initActions'
import MyAvaliableOffers from '../../services/OffersService/MyAvaliableOffers'

export function * getOffers ({ payload }) {
  try {
    const { offset } = payload
    if (offset === 0) {
      yield put(myOffersActions.clearOffers())
    }
    const { data, results } = yield call(MyAvaliableOffers.get, payload)
    yield put(myOffersActions.getOffersSuccess({ data, results }))
    if (payload?.filterBy === 'hot') yield put(initActions.hotOffersSeen({ data, results }))
  } catch ({ message }) {
    yield put(myOffersActions.getOffersFailure(message))
  }
}

export function * markFavorite ({ payload }) {
  try {
    yield call(MyAvaliableOffers.markUnmark, payload)
    yield put(myOffersActions.markFavoriteSuccess(payload))
  } catch ({ message }) {
    yield put(myOffersActions.markFavoriteFailure(message))
  }
}

export function * onGetOffers () {
  yield takeEvery(myOffersTypes.GET_OFFERS, getOffers)
}

export function * onMarkFavorite () {
  yield takeEvery(myOffersTypes.MARK_FAVORITE, markFavorite)
}

export function * myOffersSaga () {
  yield all([
    call(onGetOffers),
    call(onMarkFavorite)
  ])
}
